import { API_URL } from "../env.js";
import axios from "axios";
import moment from "moment";
var openpgp = require("openpgp");
import { getUserBook } from "../requests";
import * as notem from '../models/Note.js';
import {encrypter} from '../models/Encrypt';
import PouchDB from "pouchdb";

import { wrapRequest } from "../helpers";
import qs from "query-string";

export default {
    state: {
        loading: false,
        count: 0,
        user: null,
        author: null,
        pages: [],
        books: [],
        members: [],
        notes: [],
        bufferNotes: [],
        note: null,
        oldNote: null,
        suggestions: null,
        book: null,
        showLoginPopup: false,
        book_error: false,
        message: null,
        terms: [],
        selected_term: null,
        admin_book_terms: [],
        admin_book_search_terms: [],
        admin_book_search: {
            query: "",
            category: null,
            page: 1
        },
        notes_search: {
            query: "",
            category: null,
            page: 1
        },
        pub_terms: [],
        has_changed: false, // keep track of whether the note has changed
        privateKey: "",
        publicKey: "",
        globalLoading: {
            loading: false,
            text: ""
        },
        token: null,
        showSearch: false,
        showOptions: false,
        showRecent: false,
        recentNotes: null,
        favoriteNotes: null,
        showFavorite: false,
        defaultBook: null,
        notesFetchKey: "",
        pouch: null,
        route: null,
        unlocked: {},
        config: {
            visibility: {
                private: 0,
                locked: 1,
                public: 5,
            }
        },
        showUnlocker: false,
        unlocking: null,
        child_books: [],
    },
    mutations: {
        login(state, user) {
            state.user = user;
        },
        USER(state, user) {
            state.user = user;
        },
        mSetSettings(state, settings) {
            state.books = settings.books;
            state.defaultBook = settings.defaultBook;
        },
        mSetDefaultBook(state, defaultBook) {
            state.defaultBook = defaultBook;
        },
        mSetUser(state, user) {
            state.user = user;
        },
        mSetAuthor(state, author) {
            state.author = author;
        },
        mSetBooks(state, books) {
            state.books = books;
        },
        mSetBookX(state, book) {
            const index = state.books.findIndex(x => x.id === book.id);
            state.books.splice(index, 1, book);
        },
        mSetBook(state, book) {
            state.book = book;
        },
        mSetChildBooks(state, child_books) {
            state.child_books = child_books;
        },
        // mSetNote(state, note) {
        //     state.note = note;
        // },
        mSetNote(state, note) {
            const index = state.notes.findIndex(x => x.id === note.id);
            state.notes.splice(index, 1, note);
        },
        mSetBufferNote(state, note) {
            const index = state.bufferNotes.findIndex(x => x.id === note.id);
            state.bufferNotes.splice(index, 1, note);
        },
        mSetNotes(state, notes) {
            state.notes = notes;
        },
        mSetBufferNotes(state, notes) {
            state.bufferNotes = notes;
        },
        mAddLastNote(state, lastNote) {
            state.notes.push(lastNote);
        },
        mUnshiftNote(state, note) {
            state.notes.unshift(note);
        },
        mPopNote(state) {
            state.notes.pop();
        },
        mSetHasChanged(state, hasChanged) {
            state.has_changed = hasChanged;
        },
        mSetOldNote(state, oldNote) {
            state.oldNote = oldNote;
        },
        mSetTerms(state, terms) {
            state.terms = terms;
        },
        mSetRecentNotes(state, recentNotes) {
            state.recentNotes = recentNotes;
        },
        mShowRecent(state, showRecent) {
            state.showRecent = showRecent;
        },
        mSetFavoriteNotes(state, favoriteNotes) {
            state.favoriteNotes = favoriteNotes;
        },
        mShowFavorite(state, show) {
            state.showFavorite = show;
        },
        mShowSearch(state, showSearch) {
            state.showSearch = showSearch;
        },
        mShowOptions(state, showOptions) {
            state.showOptions = showOptions;
        },
        mCloseBookNavDropdowns(state) {
            state.showOptions = false;
            state.showRecent = false;
            state.showFavorite = false;
            state.showSearch = false;
        },
        mSetAdminBookSearchTerms(state, admin_book_search_terms) {
            state.admin_book_search_terms = admin_book_search_terms;
        },
        mSetNotesFetchKey(state, notesFetchKey) {
            state.notesFetchKey = notesFetchKey;
        },
        mReplaceNoteTerms(state, note) {
            const index = state.notes.findIndex(x => x.id === note.id);
            state.notes[index].terms = note.terms;
        },
        notes(state, notes) {
            state.notes = notes;
        },
        note(state, note) {
            state.note = note;
        },
        suggestions(state, suggestions) {
            state.suggestions = suggestions;
        },
        book(state, book) {
            state.book = book;
        },
        MESSAGE(state, message) {
            state.message = message;
        },
        MEMBERS(state, members) {
            state.members = members;
        },

        mFavoriteNote(state, note_id) {
            const index = state.notes.findIndex(x => x.id === note_id);
            state.notes[index].favorite = !state.notes[index].favorite;
        },
        mSetRoute(state, route) {
            state.route = route;
        },

        mDeleteNote(state, note_id) {
            const index = state.notes.findIndex(x => x.id === note_id);
            state.notes.splice(index, 1);
        },

        mMoveBufferNotes(state) {
            console.log('bufferNotes', state.bufferNotes, state.bufferNotes[0]);

            let bufferNote = state.bufferNotes.splice(0, 1);
            console.log('bufferNote', bufferNote[0]);
            state.notes.push(bufferNote[0]);

        },

        mRemoveNote(state, note_id) {
            const index = state.notes.findIndex(x => x.id === parseInt(note_id));
            state.notes.splice(index, 1);
        },
        ADD_MESSAGE(state, message) {
            state.notes.unshift(message);
        },

        TOGGLE_LOGIN_POPUP(state) {
            state.showLoginPopup = !state.showLoginPopup;
        },
        SET_GROUP_ERROR(state, book_error_message) {
            state.book_error = book_error_message;
        },
        SET_STATE(state, { key, data }) {
            state[key] = data;
        },
        LOADING(state, loading) {
            state.loading = loading;
        },
        GLOBAL_LOADING(state, globalLoading) {
            state.globalLoading = globalLoading;
        },
        UPDATE_TERM_IN_LIST(state, newTerm) {
            state.terms = state.terms.map(term => {
                if (term.id === newTerm.id) {
                    return Object.assign({}, newTerm);
                }
                return term;
            });
        },
        // mAddTermToNote(state, term) {
        //     const index = state.notes.findIndex(x => x.id === term.note_id);
        //     state.notes[index].terms.unshift(term);
        // },
        // DELETE_NOTE_TERM(state, term) {
        //     const index = state.terms.indexOf(term);
        //     state.terms.splice(index, 1);
        // },
        CLEAR_NOTE_TERMS(state) {
            state.terms = [];
        },
        mSetNoteTerms(state, terms) {
            state.terms = terms;
        },
        SET_TOKEN(state, token) {
            state.token = token;
            localStorage.setItem("ruminote.apiAccessToken", token);
        },
        mSetPouch(state, pouch) {
            state.pouch = pouch;
        },
        mShowUnlocker(state, {status, unlocking}) {
            state.showUnlocker = status;
            state.unlocking = unlocking;
        },
        mUnlockBook(state, unlocked) {
            state.unlocked = unlocked;
        },
    },

    actions: {
        async INIT({ commit, getters, dispatch }) {
            console.log('hello loki')
            // If there is a user in Pouch, assume the user is logged in
            const token = localStorage.getItem("ruminote.apiAccessToken");
            let loggedIn = false;
            if (token) {
                loggedIn = true;
                commit("SET_TOKEN", token);
            }

            if (navigator.onLine && loggedIn) {
                dispatch('aSyncNotes');
                dispatch('fillLocalDatabase');
            }

            await openpgp.initWorker({ path: "/openpgpjs/openpgp.worker.js" }); // set the relative web worker path
        },

        aToggleUnlocker({commit, state}, {status = false, unlocking}) {
            commit('mShowUnlocker', {status: !state.showUnlocker, unlocking});
        },

        aUnlockBook({commit, state}, book) {
            let unlocked = Object.assign({}, state.unlocked);
            unlocked[book.id] = {};
            commit('mUnlockBook', unlocked);
        },

        async aGetBook({dispatch}, book_id) {
            let lokiNotes = this._vm.$lokiNotes;
            await dispatch('getDB');
            let books = lokiNotes.getCollection('books');
            if (books === null) {
                return null;
            }
            let book = books.findOne({ 'id': book_id });
            return book;
        },

        async aSyncNotes({dispatch, getters}) {
            console.log('asyncnotes');
            // Sort the local notes by updated_at. Exclude any notes that are dirty (updated locally but not synced).
            let lokiNotes = this._vm.$lokiNotes;

            await dispatch('getDB');
            let notes = lokiNotes.getCollection('notes');
            if (notes === null) {
                return;
            }
            let updated_at = 0;
            if (notes.count() > 0) {
                let newest = notes.chain().simplesort("updated_at", true).limit(1).data();
                updated_at = newest[0].updated_at;
            }
            if (updated_at === null || updated_at === 0) return;

            console.log('updated_at', updated_at);

            // Send the most recent updated_at to the server which will get any notes updated after that.
            let uri = `${API_URL}/admin/sync/updated?updated_at=${updated_at}&type=notes`;
            axios.get(uri, getters.authHeaders).then(res => {
                console.log("res updates", res.data);
                let newNotes = res.data.notes;
                // Replace relevant notes in local database with notes from server
                newNotes.map(note => {
                    let lokiNote = notes.findOne({ 'id': note.id });
                    console.log('syncing note', lokiNote);
                    let updatedNote = Object.assign({}, lokiNote, note);
                    console.log('updatedNote', updatedNote);

                    notes.update(updatedNote);
                });
            });

        },

        async aSyncNote({commit, getters, dispatch}, note_id) {
            let uri = `${API_URL}/admin/notes/${note_id}/sync`;
            axios.get(uri, getters.authHeaders).then(res => {
                let note = res.data;
                dispatch('aUpdateNote', note);
            });
        },

        async fillLocalDatabase({commit, getters, dispatch}) {
            setInterval(() => {
                dispatch('aRunQueue')
            }, 10000);

            let user = null;

            if (this._vm.$lokiNotes) {
                // Get the user from loki
                let lokiNotes = this._vm.$lokiNotes;
                await dispatch('getDB');
                let users = lokiNotes.getCollection('users');
                if (users === null) {
                    users = lokiNotes.addCollection('users');
                }
                if (users.count() > 0) {
                    user = users.data[0];
                } else {
                    let res = await axios.get(`${API_URL}/user`, getters.authHeaders);
                    user = res.data;
                    users.insert(user);
                }

                // Get any new notes and save them to the local db
                let notes = lokiNotes.getCollection('notes');
                if (notes === null) {
                    notes = lokiNotes.addCollection('notes');
                }
                let created_at = 0;
                if (notes.count() > 0) {
                    let newest = notes.chain().simplesort("created_at", true).limit(1).data();
                    created_at = newest[0].created_at;
                }
                let uri = `${API_URL}/admin/sync/new?created_at=${created_at}&type=notes`;
                axios.get(uri, getters.authHeaders).then(res => {
                    let newNotes = res.data.notes;
                    newNotes.map(note => {
                        notes.insert(note);
                    });
                });

                // Get any new books and save them to the local db
                created_at = 0;
                var books = lokiNotes.getCollection('books');
                if (books === null) {
                    books = lokiNotes.addCollection('books');
                }
                if (books.count() > 0) {
                    let newest = books.chain().simplesort("created_at", true).limit(1).data();
                    created_at = newest[0].created_at;
                }
                uri = `${API_URL}/admin/sync/new?created_at=${created_at}&type=books`;
                axios.get(uri, getters.authHeaders).then(res => {
                    console.log("res", res.data);
                    let newBooks = res.data.books;
                    newBooks.map(book => {
                        books.insert(book);
                    });
                });
            }

            // Get the user from the API (if no loki)
            if (user === null) {
                let res = await axios.get(`${API_URL}/user`, getters.authHeaders);
                user = res.data;
            }
            commit("USER", user);
        },

        async aPouchDox() {

            // this._vm.$pouchDox.test.destroy();
            let users = await this._vm.$pouchDox.users.allDocs();
            if (users.rows.length > 0) {
                commit("mSetUser", users.rows[0]);
            } else if (loggedIn) {
                axios.get(`${API_URL}/user`, getters.authHeaders).then(response => {
                    let user = response.data;
                    user._id = String(user.id);
                    this._vm.$pouchDox.users.put(user).catch(function(err) {
                        console.log(err);
                    });
                    commit("USER", user);
                })
                    .catch(function(error) {
                        // handle error
                        console.log(error);
                    });
            }

            // Get any new notes and save them to the local db
            let notesInfo = await this._vm.$pouchDox.notes.info();
            let created_at = 0;
            if (notesInfo.doc_count !== 0) {
                await this._vm.$pouchDox.notes.createIndex({
                    index: { fields: ["created_at"] }
                });
                await this._vm.$pouchDox.notes.createIndex({
                    index: { fields: ["book_id"] }
                });
                let sortedNotes = await this._vm.$pouchDox.notes
                    .find({
                        selector: {
                            $and: [
                                { created_at: { $gte: null } },
                                { book_id: { $gte: null } }
                            ]
                        },
                        sort: [{ created_at: "desc" }],
                        limit: 1
                    })
                    .catch(e => {
                        console.log("there was an error", e);
                    });

                created_at = sortedNotes.docs[0].created_at;
            }
            let uri = `${API_URL}/admin/sync/new?created_at=${created_at}&type=notes`;
            axios.get(uri, getters.authHeaders).then(res => {
                console.log("res", res.data);
                let notes = res.data.notes;
                notes.map(note => {
                    note._id = String(note.id);
                    this._vm.$pouchDox.notes.put(note).catch(function(err) {
                        console.log(err);
                    });
                });
            });

            created_at = 0;

            // Get any new books and save them to the local db
            let booksInfo = await this._vm.$pouchDox.books.info();
            if (booksInfo.doc_count !== 0) {
                await this._vm.$pouchDox.books.createIndex({
                    index: { fields: ["created_at"] }
                });
                let sortedBooks = await this._vm.$pouchDox.books
                    .find({
                        selector: {
                            created_at: { $gte: null }
                        },
                        sort: [{ created_at: "desc" }],
                        limit: 1
                    })
                    .catch(e => {
                        console.log("there was an error", e);
                    });

                created_at = sortedBooks.docs[0].created_at;
            }
            uri = `${API_URL}/admin/sync/new?created_at=${created_at}&type=books`;
            axios.get(uri, getters.authHeaders).then(res => {
                console.log("res", res.data);
                let books = res.data.books;
                books.map(book => {
                    book._id = String(book.id);
                    this._vm.$pouchDox.books.put(book).catch(function(err) {
                        console.log(err);
                    });
                });
            });

        },
        aSetNoteTerms({ commit }, terms) {
            commit("mSetNoteTerms", terms);
        },
        aSetHasChanged({ commit }, hasChanged) {
            commit("mSetHasChanged", hasChanged);
        },
        aShowSearch({ commit }, { show, closeOthers = true }) {
            if (closeOthers) {
                commit("mCloseBookNavDropdowns");
            }
            commit("mShowSearch", show);
        },
        aShowOptions({ commit }, { show, closeOthers = true }) {
            if (closeOthers) {
                commit("mCloseBookNavDropdowns");
            }
            commit("mShowOptions", show);
        },
        aShowRecent({ commit }, { show, closeOthers = true }) {
            if (closeOthers) {
                commit("mCloseBookNavDropdowns");
            }
            commit("mShowRecent", show);
        },
        aShowFavorite({ commit }, { show, closeOthers = true }) {
            if (closeOthers) {
                commit("mCloseBookNavDropdowns");
            }
            commit("mShowFavorite", show);
        },
        aGetRecentNotes({ commit, getters, state }, book_id) {
            let uri = `${API_URL}/admin/notes/recent`;
            if (book_id) {
                uri = uri + `?book=${book_id}`;
            }
            axios.get(uri, getters.authHeaders).then(res => {
                commit("mSetRecentNotes", res.data.notes);
                commit("mShowRecent", true);
            });
        },
        aGetFavoriteNotes({ commit, getters, state }, book_id) {
            let uri = `${API_URL}/admin/notes/favorites`;
            if (book_id) {
                uri = uri + `?book=${book_id}`;
            }
            axios.get(uri, getters.authHeaders).then(res => {
                commit("mSetFavoriteNotes", res.data.notes);
                commit("mShowFavorite", true);
            });
        },
        aGetSettings({ commit, getters }) {
            const authHeaders = getters.authHeaders;
            let uri = `${API_URL}/admin/settings`;
            axios
                .get(uri, authHeaders)
                .then(response => {
                    commit("mSetSettings", response.data);
                })
                .catch(function(error) {
                    // handle error
                    console.log(error);
                });
        },
        aSetDefaultBook({ commit }, defaultBook) {
            commit("mSetDefaultBook", defaultBook);
        },

        async aGetBooks({ commit, getters, dispatch }) {

            const authHeaders = getters.authHeaders;
            let uri = `${API_URL}/admin/home`;
            axios
                .get(uri, authHeaders)
                .then(response => {
                    commit('mSetBooks', response.data.books);
                })
                .catch(function(error) {
                    // handle error
                    console.log(error);
                });

            return;

            await dispatch('getDB');
            let collection = this._vm.$lokiNotes.getCollection('books');
            let books = collection.chain().simplesort("created_at", true).data().reverse();
            commit('mSetBooks', books);

        },

        GET_USER({ commit, getters }) {
            commit("SET_TOKEN", localStorage.getItem("ruminote.apiAccessToken"));
            let uri = `${API_URL}/user`;
            let authHeaders = getters.authHeaders;
            axios
                .get(uri, authHeaders)
                .then(response => {
                    commit("USER", response.data);
                })
                .catch(function(error) {
                    // handle error
                    console.log(error);
                });
        },
        async LOGOUT({ commit, dispatch }) {
            let uri = `/logout`;
            let reqData = {
                endpoint: uri,
                data: {},
                type: 'GET',
            };
            dispatch('aMakeRequest', {data: reqData}).then(() => {
                if (this._vm.$lokiNotes) {
                    this._vm.$lokiNotes.removeCollection('notes');
                    this._vm.$lokiNotes.removeCollection('books');
                    this._vm.$lokiNotes.removeCollection('users');
                    this._vm.$lokiNotes.saveDatabase();
                }
                localStorage.removeItem("vuex");
                dispatch("REMOVE_KEYS_FROM_LOCAL_STORAGE");
                commit("USER", "");
                commit("mSetNotes", []);
                commit("mSetBooks", []);
            })
        },

        async aGetUserBook({ commit, getters }, book_id) {
            const url = `${API_URL}/admin/books/${book_id}/update`;
            // const res = await wrapRequest((url, config) => axios.get(url, config));
            const res = await getUserBook(url, getters.authHeaders);
            if (res) {
                commit("mSetBook", res.data.book);
            }
            return res.data;
        },

        async aUpdateNotesVisibility({commit, dispatch}, {book, user_password}) {
            await dispatch('getDB');

            // Update server database
            let uri = `/books/${book.id}/notes/visibility`;
            const data = {
                visibility: book.visibility,
                user_password: user_password,
            };
            let reqData = {
                endpoint: uri,
                data: data,
                type: 'POST',
            };
            dispatch('aMakeRequest', {data: reqData}).then((res) => {
                // update the visibility in loki
                if (this._vm.$lokiNotes) {
                    let collection = this._vm.$lokiNotes.getCollection('notes');
                    let notes = collection.chain()
                        .find({book_id: Number(book.id)})
                        .data();
                    notes.map((note) => {
                        note.visibility = book.visibility;
                        collection.update(note); // update the local database
                    });
                }
            })
        },

        async aLockBook({commit, state, dispatch}, book_id) {
            let unlocked = Object.assign({}, state.unlocked);
            delete unlocked[book_id];
            commit('mUnlockBook', unlocked);
            return true;
        },

        aGetLastNote({ commit, getters }, { uri }) {
            let authHeaders = getters.authHeaders;

            axios
                .get(uri, authHeaders)
                .then(function(response) {
                    if (response.data.error === false) {
                        let notes = response.data.notes;
                        // Get the last note
                        const lastNote = notes[notes.length - 1];
                        commit("mAddLastNote", lastNote);
                    } else if (response.data.error) {
                        commit("SET_GROUP_ERROR", response.data.message);
                    }
                })
                .catch(function(error) {
                    // handle error
                    console.log(error);
                    commit("LOADING", false);
                });
        },

        getDB () {
            return new Promise((resolve, reject) => {
                try {
                    let interval = setInterval(() => {
                        if (this._vm.$lokiLoaded) {
                            clearInterval(interval)
                            resolve(true)
                        }
                    }, 100)
                } catch (error) {
                    reject(error)
                }
            })
        },
        async aGetNotesAdmin(
            { commit, getters, dispatch, state },
            { uri, showLoading = true, search = null, notesFetchKey = null, local = true }
        ) {
            console.log('another change');
            console.log('aGetNotesAdmin', search);
            if (search) {
                // Create the admin_book_search from the query
                commit("SET_STATE", { key: "admin_book_search", data: search });
                // Get notes from server if there is a query or category filter (or if there's no queries)
                let conditions = search.query || search.category;
                if (true) {
                    local = false;
                }
            }
            local = false;

            if (showLoading) {
                commit("LOADING", true);
            }


            let notes = [];
            let books = [];
            let child_books = [];
            let book = {};

            if (local) {
                console.log('local', local);
                await dispatch('getDB');

                let page = search.page;
                let perPage = search.perPage ? search.perPage : 15;
                let offset = (Number(page) -1) * Number(perPage);
                let collection = this._vm.$lokiNotes.getCollection('notes');

                // let sorted = notes.chain().find({book_id: search.book}).data();
                notes = collection.chain()
                    .simplesort("created_at", true)
                    .find({book_id: Number(search.book)})
                    .offset(offset)
                    .limit(15)
                    .data()
                    .reverse();
                book = notes[0].book;
            } else {
                console.log('getting notes for book')
                let response = await axios.get(uri, getters.authHeaders);
                notes = response.data.notes;
                book = response.data.book;
                if (response.data.child_books) {
                    child_books = response.data.child_books;
                }
                books = response.data.books;
            }

            commit("mSetBook", book);
            commit("mSetChildBooks", child_books);
            commit("mSetBooks", books);
            notes.map((note) => {
                dispatch('aSetNote', note);
            });
            commit("mSetNotes", notes);
            // // commit("book", notes[0].book);
            // dispatch("aReformatNoteDates", state.notes).then((resNotes) => {
            //     dispatch("aDecryptNotes", resNotes).then((notesRes) => {
            //         notesRes.map((note) => {
            //             commit("mSetNote", note);
            //         })
            //     })
            // });
            commit("mSetNotesFetchKey", notesFetchKey);

            if (showLoading) {
                commit("LOADING", false);
            }
        },

        async aGetNoteAdmin({ commit, getters, dispatch, state },
                      { uri, showLoading = true, local = true })
        {
            local = false;

            if (showLoading) {
                commit("LOADING", true);
            }

            let note = null;
            let child_books = [];
            let book = {};
            let books = [];

            if (local && this._vm.$lokiNotes) {
                await dispatch('getDB');

                let collection = this._vm.$lokiNotes.getCollection('notes');
                let note = collection.findOne({ 'id': Number(this.$route.params.note) });
                book = note.book;
            } else {
                let response = await axios.get(uri, getters.authHeaders);
                note = response.data.note;
                book = note.book;
                books = response.data.books;
                if (response.data.child_books) {
                    child_books = response.data.child_books;
                }
            }

            commit("mSetNotesFetchKey", "note=" + note.id);
            commit("mSetBooks", books);

            commit("mSetBook", book);
            commit("mSetChildBooks", child_books);

            dispatch("aSetNote", note);
            dispatch("aSetBook", book);
            dispatch("aSetHasChanged", false);

            if (showLoading) {
                commit("LOADING", false);
            }
        },

        async aSetNote({commit}, note) {
            let copy = JSON.parse(JSON.stringify(note));
            // if the note has a date, convert it to local time
            if (note.date) {
                let UtcDate = note.date;
                copy.date = notem.convertUtcToLocal(UtcDate);
            }

            // maybe decrypt content
            if (note.is_encrypted && !note.decrypted && note.encrypted) {
                const encryptedText = await encrypter.decryptText(note.encrypted);
                copy.encrypted = encryptedText.data;
                copy.decrypted = true;
            }
            commit("mSetNote", copy);
        },

        async convertServerNoteToState({}, note) {

        },

        async aGetBufferNotes({commit, dispatch, getters, state}, {uri, notesFetchKey}) {
            let response = await axios.get(uri, getters.authHeaders);
            let notes = response.data.notes;
            commit("mSetBufferNotes", notes);
            dispatch("aReformatNoteDates", state.bufferNotes).then((resNotes) => {
                resNotes.map((note) => {
                    commit("mSetBufferNote", note);
                });
                dispatch("aDecryptNotes", state.bufferNotes).then((notesRes) => {
                    notesRes.map((note) => {
                        commit("mSetBufferNote", note);
                    })
                })
            });
        },

        async aMoveBufferNotes({commit, state}, toMove) {
            if (state.bufferNotes.length > 0) {
                commit('mMoveBufferNotes');
            }
        },

        aReformatNoteDates({ commit, state, dispatch }, notes) {
            let copy = [];
            notes.map(async note => {
                let noteCopy = Object.assign({}, note);
                // if the note has a date, convert it to UTC
                if (noteCopy.date) {
                    // Update notes.date (UTC should be 4 or 5 hours ahead of local time for EST/EDT)
                    // Do not set date of the local copy of the note to dateUtc.
                    // Keep the date of the local copy in the local format. The package will update it.
                    // This works whether date is a string or Date object
                    let localizedDateString = notem.convertUtcToLocal(UtcDate);;
                    noteCopy.date = localizedDateString;
                }
                copy.push(noteCopy);
            });
            return copy;
        },
        async aDecryptNotes({ commit, state, dispatch }, notes) {
            if (!state.privateKey) {
                await dispatch("SAVE_KEYS_FROM_LOCAL_STORAGE_TO_STATE");
            }
            let copy = [];
            notes.map(async note => {
                let noteCopy = Object.assign({}, note);
                // if the note has a date, convert it to UTC
                if (noteCopy.is_encrypted && !noteCopy.decrypted) {
                    try {
                        const decryptedText = await encrypter.decryptText(note.encrypted);
                        noteCopy.encrypted = decryptedText.data;
                        noteCopy.decrypted = true;
                        commit("mSetNote", noteCopy);
                    } catch (e) {
                        // errored
                    }
                }
                copy.push(noteCopy);
            });
            return copy;
        },
        PUB_SEARCH({ commit }, { uri }) {
            axios.get(uri).then(response => {
                commit("notes", response.data.notes);
                commit("SET_STATE", { key: "terms", data: response.data.terms });
            });
        },
        SEARCH({ commit }, { book_id, query }) {
            let uri = API_URL + "/books/" + book_id + "/notes/search?query=" + query;
            axios.get(uri).then(response => {
                commit("notes", response.data.notes.data);
            });
        },
        TOGGLE_LOGIN_POPUP({ commit }) {
            commit("TOGGLE_LOGIN_POPUP");
        },

        // async MANAGE_KEYS_AFTER_REGISTER({commit, state, dispatch}, user) {
        //     // Generate user keys
        //     let publicKeyArmored = '';
        //     let privateKeyArmored = '';
        //     const key = await dispatch('GENERATE_USER_KEYS', {user});
        //     await dispatch('SAVE_KEYS_TO_USER_ACCOUNT', {key, user});
        //     publicKeyArmored = key.publicKeyArmored;
        //     privateKeyArmored = key.privateKeyArmored;
        //     // Save keys to local storage
        //     await dispatch('SAVE_KEYS_TO_LOCAL_STORAGE', {publicKeyArmored, privateKeyArmored, user});
        //     await dispatch("SAVE_KEYS_FROM_LOCAL_STORAGE_TO_STATE");
        //     console.log('MANAGE_KEYS_AFTER_REGISTER success');
        // },
        saveMessage({ commit }, { message }) {
            return new Promise((resolve, reject) => {
                let uri = API_URL + `/notes/${message.id}/update`;

                axios.patch(uri, message).then(response => {
                    resolve();
                });
            });
        },
        CHANGE_PRIVACY({ commit, getters, dispatch }, note) {
            let uri = `${API_URL}/admin/notes/${note.id}/update/visibility`;
            axios.patch(uri, note, getters.authHeaders).then(response => {
                commit("mSetNote", note);
            });
        },

        aDeleteNote({ commit, getters, dispatch }, note_id) {
            // remove from state
            commit("mDeleteNote", note_id);
            // remove from server
            let reqData = {
                endpoint: `/admin/notes/${note_id}/delete`,
                data: {},
                type: 'DELETE',
            };
            dispatch('aMakeRequest', {data: reqData});
            // remove from local database
            if (this._vm.$lokiNotes) {
                let lokiNotes = this._vm.$lokiNotes;
                let notes = lokiNotes.getCollection('notes');
                let lokiNote = notes.findOne({ 'id': note_id });
                if (lokiNote !== null) {
                    notes.remove(lokiNote);
                }
            }
        },

        aRemoveNote({ commit }, note_id) {
            commit("mRemoveNote", note_id);
        },

        aFavoriteNote({ commit, getters, dispatch }, note) {
            // update the state
            commit("mSetNote", note);
            // update the server
            let reqData = {
                endpoint: `/admin/notes/${note.id}/favorite`,
                data: {},
                type: 'GET',
            };
            dispatch('aMakeRequest', {data: reqData});
            // update the local database
            if (this._vm.$lokiNotes) {
                let lokiNotes = this._vm.$lokiNotes;
                let localNotes = lokiNotes.getCollection('notes');
                let lokiNote = localNotes.findOne({ 'id': note.id });
                let updatedNote = Object.assign({}, lokiNote, note);
                localNotes.update(updatedNote); // update the local database
            }
        },

        // aDeleteNoteTerm({ commit, getters, state }, { term, note }) {
        //   const termIndex = note.terms.findIndex(x => x.id === term.id);
        //   note.terms.splice(termIndex, 1);
        //   commit("mSetNote", note);
        //
        //   // commit('DELETE_NOTE_TERM', term);
        //   let uri = `${API_URL}/admin/notes/${note.id}/terms/${term.name}/delete`;
        //   axios.delete(uri, getters.authHeaders);
        // },

        NOTES_USER_NOTE({ commit, getters }, uri) {
            axios.get(uri, getters.authHeaders).then(response => {
                // commit('SET_STATE', { key: 'note', data: response.data.note });
                commit("mSetNote", response.data.note);
                commit("mSetBook", response.data.book);
                commit("mSetAuthor", response.data.author);
            });
        },

        BOOKS_USER({ commit, getters }, uri) {
            axios.get(uri, getters.authHeaders).then(response => {
                commit("SET_STATE", { key: "author", data: response.data.author });
                commit("SET_STATE", { key: "books", data: response.data.books });
            });
        },

        // Get public notes from a book
        aGetUsersBook({ commit }, uri) {
            axios.get(uri).then(response => {
                commit("SET_STATE", { key: "author", data: response.data.author });
                commit("SET_STATE", { key: "book", data: response.data.book });
                commit("SET_STATE", { key: "notes", data: response.data.notes });
            });
        },
        // Get public notes from a book
        aGetPublicBook({ commit }, uri) {
            axios.get(uri).then(response => {
                commit("SET_STATE", { key: "author", data: response.data.author });
                commit("SET_STATE", { key: "book", data: response.data.book });
                commit("SET_STATE", { key: "notes", data: response.data.notes });
            });
        },
        aGetFavs({ commit, getters }, uri) {
            axios.get(uri, getters.authHeaders).then(response => {
                commit("SET_STATE", { key: "notes", data: response.data.notes });
            });
        },
        LOADING: ({ commit }, loading) => {
            commit("LOADING", loading);
        },
        GLOBAL_LOADING: ({ commit }, globalLoading) => {
            commit("GLOBAL_LOADING", globalLoading);
        },
        FLASH_MESSAGE: ({ commit }, message) => {
            commit("SET_STATE", { key: "flashMessage", data: message });
        },

        async UPDATE_NOTE_VERBOSE({ commit, dispatch }, { notes }) {
            commit("LOADING", true);
            await dispatch("aUpdateNotes", { notes: notes });
            commit("LOADING", false);
        },

        async aUpdateNoteVerbose({ commit, dispatch }, note) {
            commit("LOADING", true);
            await dispatch("aUpdateNote", note);
            commit("LOADING", false);
        },

        async aUpdateNote({commit, state, dispatch, getters}, note) {
            // For some reason, the note passed to aUpdateNoteServerDatabase is updated by aUpdateNoteLocalDatabase; heance sending a copy instead of the actual note.
            let copy = JSON.parse(JSON.stringify(note));
            dispatch('aUpdateNoteState', copy);
            dispatch('aUpdateNoteLocalDatabase', copy);
            dispatch('aUpdateNoteServerDatabase', copy);
        },

        async aUpdateNoteState({commit, state, dispatch, getters}, note) {
            let noteModifiedForState = JSON.parse(JSON.stringify(note));

            // Change updated_at (will be used by server later)
            noteModifiedForState.updated_at = notem.convertLocalToUtc(moment().toDate());

            // maybe create a default title
            // if there is no title
            // and it's not a date type book (notes in date type books don't need a title)
            // automatically create a title for a note
            if (note.new && !note.title && note.book.type !== "date") {
                noteModifiedForState.title = notem.createDefaultTitle(note.book.title);
            }

            // Update the state
            dispatch("aSetNote", noteModifiedForState);
        },

        async aUpdateNoteLocalDatabase({commit, state, dispatch, getters}, note) {
            if (this._vm.$lokiNotes) {
                // get the Loki db connection
                let lokiNotes = this._vm.$lokiNotes;
                let localNotes = lokiNotes.getCollection('notes');
                // Use the note from the local database instead of making a copy of the one from the state
                let noteFromClientDatabase = localNotes.findOne({ 'id': note.id });

                // maybe convert date
                // if the note has a date, convert it to UTC
                if (note.date) {
                    let localDateString = note.date;
                    noteFromClientDatabase.date = notem.convertLocalToUtc(localDateString);
                }

                // maybe encrypt content
                // if the note is encrypted, first encrypt the content before saving it to the local database
                // else just save the content
                if (note.is_encrypted && note.encrypted) {
                    const encryptedText = await encrypter.encryptText(note.encrypted);
                    noteFromClientDatabase.encrypted = encryptedText.data;
                } else {
                    noteFromClientDatabase.content = note.content;
                }

                // Update updated_at
                // Prepare the updated_at field for the server
                // Update the updated_at for the state and client note but not for the server note.
                // The server would throw an error because it would think that the note was updated somewhere else if the updated_at of the note for the server didn't match the updated_at of the note on the server
                let newUpdatedAt = notem.convertLocalToUtc(moment().toDate());
                noteFromClientDatabase.new_updated_at = newUpdatedAt;
                noteFromClientDatabase.updated_at = newUpdatedAt;

                // maybe create a default title
                // if there is no title
                // and it's not a date type book (notes in date type books don't need a title)
                // automatically create a title for a note
                if (note.new && !note.title && note.book.type !== "date") {
                    noteFromClientDatabase.title = notem.createDefaultTitle(note.book.title);
                }
                noteFromClientDatabase.decrypted = false; // this was getting saved as true and confusing the front end

                // Update the client database
                localNotes.update(noteFromClientDatabase); // update the local database
            }
        },

        async aUpdateNoteServerDatabase({commit, state, dispatch, getters}, note) {
            let noteModifiedForServerDatabase = JSON.parse(JSON.stringify(note));
            // maybe convert date
            // if the note has a date, convert it to UTC
            if (note.date) {
                let localDateString = note.date;
                noteModifiedForServerDatabase.date = notem.convertLocalToUtc(localDateString);
            }

            // maybe encrypt content
            // if the note is encrypted, first encrypt the content before saving it to the local database
            // else just save the content
            if (note.is_encrypted && note.encrypted) {
                const encryptedText = await encrypter.encryptText(note.encrypted);
                noteModifiedForServerDatabase.encrypted = encryptedText.data;
            }

            // Update updated_at
            // Prepare the updated_at field for the server
            // Update the updated_at for the state and client note but not for the server note.
            // The server would throw an error because it would think that the note was updated somewhere else if the updated_at of the note for the server didn't match the updated_at of the note on the server
            let newUpdatedAt = notem.convertLocalToUtc(moment().toDate());
            noteModifiedForServerDatabase.new_updated_at = newUpdatedAt;

            // maybe create a default title
            // if there is no title
            // and it's not a date type book (notes in date type books don't need a title)
            // automatically create a title for a note
            if (note.new && !note.title && note.book.type !== "date") {
                noteModifiedForServerDatabase.title = notem.createDefaultTitle(note.book.title);
            }

            // update the server database
            let uri = `/admin/notes/update`;
            const data = {
                notes: [noteModifiedForServerDatabase]
            };

            let reqData = {
                endpoint: uri,
                data: data,
                type: 'POST',
            };

            dispatch('aAttemptRequest', {data: reqData});
        },

        /**
         * This method takes an array of notes, encrypts any content, and sends it to the database to be updated.
         * It should not know whether a note is being updated from a single page or from a list.
         * @param notes Array of note objects
         * **/
        async aUpdateNotes({ commit, state, dispatch, getters }, { notes }) {
            dispatch('aUpdateNote', notes[0]);
        },

        aAttemptRequest({dispatch}, {data}) {
            if (navigator.onLine) {
                dispatch('aMakeRequest', {data});
            } else {
                data.timestamp = moment().valueOf();
                let lokiNotes = this._vm.$lokiNotes;
                let queue = lokiNotes.getCollection('queue');
                queue.insert(data);
            }
        },

        // if attempt, if it's online, immediately make a request, else just add
        // to the queue
        async aRunQueue({commit, dispatch}) {
            if (this._vm.$lokiNotes) {
                let lokiNotes = this._vm.$lokiNotes;
                let queue = lokiNotes.getCollection('queue');
                if (queue.count() > 0) {
                    let all = queue.chain().simplesort("timestamp").data();
                    // loop through all of the action packages
                    all.map((reqData) => {
                        // continue if this action isn't being attempted (sent to server)
                        if (!reqData.attempting) {
                            reqData.attempting = true;
                            queue.update(reqData);
                            dispatch('aMakeRequest', {data: reqData}).then((res) => {
                                console.log('done', reqData);
                                queue.remove(reqData);
                            }).catch((e) => {
                                console.log('there was an error', e, all, reqData);
                                let attempts = 0;
                                if (reqData.attempts) {
                                    attempts = reqData.attempts;
                                }
                                reqData.attempts = attempts + 1;
                                reqData.attempting = false;
                                if (reqData.attempts > 3) {
                                    queue.remove(reqData);
                                } else {
                                    queue.update(reqData);
                                }
                            })
                        }
                    });
                }
            }
        },

        async aMakeRequest({commit, dispatch, getters}, {data = {}}) {
            let uri = `${API_URL}${data.endpoint}`;
            const authHeaders = getters.authHeaders;
            return new Promise((resolve, reject) => {
                axios({
                    method: data.type,
                    url: uri,
                    data: data.data,
                    headers: authHeaders.headers,
                }).then((res) => {
                    if (res.data.error) {
                        commit('error_type', res.data.error); // set an error type which may help the user resolve the error
                        dispatch("populateErrors", res.data.message);
                        reject(false);
                    } else {
                        resolve(true);
                    }
                }).catch((e) => {
                    let message = '';
                    if (e.response) {
                        message = e.response.data.message;
                    } else {
                        message = e.message;
                    }
                    dispatch("populateErrors", message);
                    reject(e);
                })

            });

        },

        aMoveNotes: ({ commit, getters }, { notes, book }) => {
            notes.map(note_id => {
                commit("mRemoveNote", note_id);
            });
            let uri = `${API_URL}/notes/move`;
            const data = {
                notes,
                book
            };
            return axios.post(uri, data, getters.authHeaders);
        },
        async LOGIN_USER({ commit, state, dispatch }, user) {
            let uri = API_URL + "/login";
            let res;
            try {
                res = await axios.post(uri, user);
            } catch (e) {
                throw e;
            }
            const userHasKeys = res.data.user.encrypter !== null;
            let userKeys = null;
            if (userHasKeys) {
                userKeys = {
                    public_key: res.data.user.encrypter.public_key,
                    private_key: res.data.user.encrypter.private_key
                };
            }
            // Save the user to the state
            commit("login", res.data.user);
            commit("SET_TOKEN", res.data.apiAccessToken);
            dispatch("MANAGE_KEYS_AFTER_AUTH", { user, userKeys });
            dispatch('fillLocalDatabase');
            return { success: true };
        },

        async MANAGE_KEYS_AFTER_AUTH(
            { commit, state, dispatch },
            { user, userKeys }
        ) {
            let publicKeyArmored = "";
            let privateKeyArmored = "";
            if (userKeys) {
                publicKeyArmored = userKeys.public_key;
                privateKeyArmored = userKeys.private_key;
            } else {
                const key = await dispatch("GENERATE_USER_KEYS", { user });
                await dispatch("SAVE_KEYS_TO_USER_ACCOUNT", { key, user });
                publicKeyArmored = key.publicKeyArmored;
                privateKeyArmored = key.privateKeyArmored;
            }
            // Save keys to local storage
            await dispatch("SAVE_KEYS_TO_LOCAL_STORAGE", {
                publicKeyArmored,
                privateKeyArmored,
                user
            });
            await dispatch("SAVE_KEYS_FROM_LOCAL_STORAGE_TO_STATE");
        },

        async REGISTER_USER({ commit, state, dispatch }, user) {
            let uri = API_URL + "/register";
            const res = await axios.post(uri, user);
            commit("USER", res.data.user);
            commit("SET_TOKEN", res.data.apiAccessToken);
            // Send in null user keys to generate a new pair
            const userKeys = null;
            dispatch("MANAGE_KEYS_AFTER_AUTH", { user, userKeys });
            return { success: true };
        },

        async aUpdateUserAccount({ commit, state, getters }, { user }) {
            // Update the password. Note that no keys are updated on the front end. The newly encrypted private key is just saved to the database.
            if (user.changePassword) {
                // Get the decrypted private key from local storage.
                let privateKeyArmoredDecrypted = localStorage.getItem(
                    "ruminote.privateKey"
                );
                const privKeyObj = (
                    await openpgp.key.readArmored(privateKeyArmoredDecrypted)
                ).keys[0];
                // Encrypt it with the new password.
                await privKeyObj.encrypt(user.newPassword);
                // Save the new encrypted armored private key to the database.
                user.newPrivateKeyArmoredEncrypted = privKeyObj.armor();
            }
            let data = {
                userData: user
            };

            let uri = `${API_URL}/admin/settings/user`;
            try {
                const res = await axios.post(uri, data, getters.authHeaders);
                commit("mSetUser", res.data.user);
                return res;
            } catch (e) {
                throw e;
            }
        },

        async GENERATE_USER_KEYS({ commit }, { user }) {
            var options = {
                userIds: [{ name: user.username, email: user.email }], // multiple user IDs
                rsaBits: 4096, // RSA key size
                passphrase: user.password // protects the private key
            };
            const key = await openpgp.generateKey(options);
            return key;
        },

        async SAVE_KEYS_TO_USER_ACCOUNT({ commit, getters }, { key, user }) {
            let uri = `${API_URL}/user/keys`;
            const data = {
                privateKey: key.privateKeyArmored,
                publicKey: key.publicKeyArmored
            };
            axios.post(uri, data, getters.authHeaders).then(res => {
                commit("USER", res.data.user);
            });
        },

        async SAVE_KEYS_TO_LOCAL_STORAGE(
            { commit },
            { publicKeyArmored, privateKeyArmored, user }
        ) {
            const privKeyObj = (await openpgp.key.readArmored(privateKeyArmored))
                .keys[0];
            await privKeyObj.decrypt(user.password);
            // Save the decrypted private key and public key to local storage
            if (typeof window !== "undefined") {
                localStorage.setItem("ruminote.privateKey", privKeyObj.armor());
                localStorage.setItem("ruminote.publicKey", publicKeyArmored);
                // localStorage.setItem('revocationCertificate', key.revocationCertificate);
            }
            commit("SET_STATE", { key: "privateKey", data: privKeyObj });
            commit("SET_STATE", { key: "publicKey", data: publicKeyArmored });
            // commit('SET_STATE', {key: 'revocationCertificate', data: key.revocationCertificate});
        },

        async SAVE_KEYS_FROM_LOCAL_STORAGE_TO_STATE({ commit }) {
            await this._vm.$createOpenpgpKeys();
            let decryptedPrivateKeyArmored = localStorage.getItem(
                "ruminote.privateKey"
            );
            let publicKeyArmored = localStorage.getItem("ruminote.publicKey");
            const privKeyObj = (
                await openpgp.key.readArmored(decryptedPrivateKeyArmored)
            ).keys[0];
            const publicKeys = (await openpgp.key.readArmored(publicKeyArmored)).keys;
            commit("SET_STATE", { key: "privateKey", data: privKeyObj });
            commit("SET_STATE", { key: "publicKey", data: publicKeys });
            return { privateKey: privKeyObj, publicKey: publicKeys };
        },

        REMOVE_KEYS_FROM_LOCAL_STORAGE({ commit }) {
            console.log('removing local storage items');
            localStorage.removeItem("ruminote.privateKey");
            localStorage.removeItem("ruminote.publicKey");
            localStorage.removeItem("ruminote.apiAccessToken");
        },

        GET_AUTH_HEADERS() {
            const apiAccessToken = localStorage.getItem("ruminote.apiAccessToken");
            let authHeaders = {
                headers: { Authorization: `Bearer ${apiAccessToken}` }
            };
            return authHeaders;
        },

        async ENCRYPT_NOTES_RECURSION({ commit, dispatch, getters }, book_id) {
            const notesBatchRes = await axios.get(
                `${API_URL}/books/${book_id}/notes/private`,
                getters.authHeaders
            );
            const notes = notesBatchRes.data.notes;
            const count = notesBatchRes.data.count;
            commit("GLOBAL_LOADING", {
                loading: true,
                text: "Encrypting " + count + " notes"
            });
            if (notes.length === 0) {
                commit("GLOBAL_LOADING", { loading: false, text: "" });
                return false;
            }
            let notesForServer = [];
            for (let i = 0; i < notes.length; i++) {
                let note = notes[i];
                // maybe check to see that this is doing the right thing.
                const encryptedText = await encrypter.encryptText(note.content);;
                let noteData = {
                    id: note.id,
                    encrypted: encryptedText.data
                };
                notesForServer.push(noteData);
            }
            let data = {
                notes: notesForServer
            };
            const encryptNotesUrl = `${API_URL}/books/${book_id}/notes/encrypt`;
            const notesUpdateRes = await axios.post(
                encryptNotesUrl,
                data,
                getters.authHeaders
            );
            dispatch("ENCRYPT_NOTES_RECURSION", book_id);
        },

        async DECRYPT_NOTES_RECURSION({ commit, dispatch, getters, state }, book_id) {
            if (!state.privateKey) {
                await dispatch("SAVE_KEYS_FROM_LOCAL_STORAGE_TO_STATE");
            }
            let url = `${API_URL}/books/${book_id}/notes/encrypted`;
            const notesBatchRes = await axios.get(url, getters.authHeaders);
            const notes = notesBatchRes.data.notes;
            const count = notesBatchRes.data.count;
            commit("GLOBAL_LOADING", {
                loading: true,
                text: "Decrypting " + count + " notes"
            });
            if (notes.length === 0) {
                commit("GLOBAL_LOADING", { loading: false, text: "" });
                return false;
            }
            let notesForServer = [];
            for (let i = 0; i < notes.length; i++) {
                let note = notes[i];
                console.log('note2', note);
                const decryptedText = await encrypter.decryptText(note.encrypted);
                let noteData = {
                    id: note.id,
                    content: decryptedText.data
                };
                notesForServer.push(noteData);
            }
            let data = {
                notes: notesForServer
            };
            const decryptNotesUrl = `${API_URL}/books/${book_id}/notes/decrypt`;
            const notesUpdateRes = await axios.post(
                decryptNotesUrl,
                data,
                getters.authHeaders
            );
            dispatch("DECRYPT_NOTES_RECURSION", book_id);
        },

        async aCreateNote({ commit, state, dispatch, getters }, book_id) {
            let data = {
                'book': book_id,
            };
            let uri = `${API_URL}/admin/notes/create`;
            let createNoteRes = await axios.post(uri, data, getters.authHeaders);
            let createdNote = Object.assign({}, createNoteRes.data.note);

            // add note to local database
            if (this._vm.$lokiNotes) {
                let lokiNotes = this._vm.$lokiNotes;
                await dispatch('getDB');
                let notes = lokiNotes.getCollection('notes');
                notes.insert(createdNote);
            }

            let book = createNoteRes.data.book;
            if (book.type === "date") {
                let localizedDateString = notem.convertUtcToLocal();
                createdNote.date = localizedDateString;
            }
            // if it's a new note, any text added will already be decrypted
            if (createdNote.is_encrypted) {
                createdNote.decrypted = true;
            }

            let books = createNoteRes.data.books;

            commit("book", book);
            createdNote.editing = true;
            commit('mUnshiftNote', createdNote);
            // commit("mSetNotes", [createdNote]);
            commit("mSetNotesFetchKey", "note=" + createdNote.id);
            // commit('mPopNote');
            commit("SET_STATE", {
                key: "terms",
                data: []
            });
            commit("mSetBooks", books);
            return createdNote.id;
        },
        aSetAuthor({ commit }, author) {
            commit("mSetAuthor", author);
        },
        aSetNotes({ commit, dispatch }, { notes, terms, notesFetchKey = null }) {
            notes.map((note) => {
                dispatch('aSetNote', note);
            });
            // commit("mSetNotes", notes);
            commit("mSetNotesFetchKey", notesFetchKey);
            if (terms !== undefined) {
                commit("mSetTerms", terms);
            }
        },
        aSetNotesSearch({ commit }, { notes, terms, book = null, author = null }) {
            commit("mSetNotes", notes);
            if (terms !== undefined) {
                commit("mSetTerms", terms);
            }
            commit("mSetBook", book);
            commit("mSetAuthor", author);
        },
        aSetBook({ commit }, book) {
            commit("mSetBook", book);
        },
        aSetBookX({ commit }, book) {
            commit("mSetBookX", book);
        },
        aReplaceNoteTerms({ commit }, terms) {
            commit("mReplaceNoteTerms", terms);
        },
        aUpdateTermInList({ commit }, term) {
            commit("UPDATE_TERM_IN_LIST", term);
        },
        aSetAdminBookSearchTerms({ commit }, adminBookSearchTerms) {
            commit("mSetAdminBookSearchTerms", adminBookSearchTerms);
        }
    },
    getters: {
        authHeaders(state) {
            let authHeaders = {
                headers: { Authorization: `Bearer ${state.token}` }
            };
            return authHeaders;
        }
    }
};
